import createRequestReducer from '../../../reducers/request';
import * as actions from '../../actions/confirmSubscriber';
/**
 * Tracks the request lifecycle of the `confirmSubscriber` action.
 *
 * Follows the `request` reducer pattern, please see those docs for more information about what state it holds.
 *
 * It has the following action map:
 *
 * - loading: confirmSubscriberStart
 * - loaded: confirmSubscriberSuccess
 * - failed: confirmSubscriberFailure
 *
 * Note that because `confirmSubscriber` only returns 1 item, the `count` and `next` values in the reducer should not be used.
 *
 * ```js
 * import { subscription } from '@minerva-analytics/pantheon';
 * const { confirmSubscriberStatus } = subscription.reducers;
 *
 * // To select data from this reducer in a component
 * import { useSelector } from 'react-redux';
 *
 * const Test = () => {
 *   // Note that you may need to change this depending on where the subscriber
 *   // model is integrated in your store
 *   const status = useSelector((state) => state.subscriber.confirmSubscriberStatus);
 *
 *   return <div>Test</div>
 * };
 * ```
 */

var confirmSubscriberStatus = createRequestReducer({
  actionMap: {
    loading: [actions.confirmSubscriberStart],
    loaded: [actions.confirmSubscriberSuccess],
    failed: [actions.confirmSubscriberFailure]
  }
});
export default confirmSubscriberStatus;